// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"e1800a36","215":"1dfee6e9","551":"6a2c8ebb"}[chunkId] + ".chunk.css";
};